import { IPopupBindings, PopupComponent } from "@directives/_misc/popup/popup.directive";
import * as angular from "angular";

export interface IPopupOptionsJson {
}

export class PopupService {

    static $inject = ["$rootScope", "$compile"];

    constructor(
        private readonly $rootScope: angular.IRootScopeService,
        private readonly $compile: angular.ICompileService
    ) { }

    showPopup(template: string, $event: MouseEvent, bindings?: any) {

        var insertedPopup = this.$compile(`<popup class="br-10 white-background"></popup>`)(this.$rootScope.$new(false)) as any;
        angular.element("popup-wrapper").append(insertedPopup);

        const insertedElementScope = this.$rootScope.$new(false);
        Object.assign(insertedElementScope, bindings);
        var insertedTemplate = this.$compile(template)(insertedElementScope) as any;
        insertedPopup.append(insertedTemplate);

        const popupScope: any = insertedPopup.length && (insertedPopup.isolateScope() || insertedPopup.scope());
        const popupComponent: IPopupBindings = popupScope.$ctrl;

        const pixelsToRightOfScreen = window.innerWidth - $event.x;
        const pixelsToBottomOfScreen = window.innerHeight - $event.y;

        popupComponent.showOnRight = pixelsToRightOfScreen > 500;
        //popupComponent.arrowPosition = "bottom";
        popupComponent.mouseEvent = $event;
        popupComponent.$onChanges({});
    }
}
